<template>
  <v-container fluid class="theme-color" style="height: 100%;">
    <Default class="dialog mb-sm-5" :class="{ xs: $vuetify.breakpoint.xsOnly }" />
  </v-container>
</template>

<script>
import Default from '../components/add/Default.vue';

export default {
  components: {
    Default
  }
};
</script>

<style lang="scss" scoped></style>
